<template>
    <div class="footer-wrapper">
        <!-- 原有的footer内容，在非移动端显示 -->
        <div data-v-0de18781="" v-show="path != '/message' && !isMobile" class="footer_container">
            <div class="content">
                <div class="site">
                    <!-- <p class="run_time">
                        <svg-icon icon-class="shandian"></svg-icon>
                        <span>本站居然运行了
                            <strong>{{ day }}</strong> 天
                            <strong>{{ hours }}</strong> 时
                            <strong>{{ minute }}</strong> 分
                            <strong>{{ second }}</strong> 秒
                        </span>
                    </p> -->
                    <p>
                        Copyright©2022-2025 <a href="https://www.mmming.cn/" target="_blank">有明仿真</a>
                        <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-left: 10px">{{
                            $store.state.webSiteInfo.recordNum
                        }}</a>
                    </p>

                </div>
    <!--            <div class="site-number">-->
    <!--                <span class="site_pv">-->
    <!--                    <i class="iconfont icon-fangwenliang"></i>-->
    <!--                    访问量-->
    <!--                    <em class="pv_num">-->
    <!--                        {{ this.$store.state.siteAccess }}-->
    <!--                    </em>-->
    <!--                </span>-->

    <!--                <span class="site_uv">-->
    <!--                    <i class="el-icon-user-solid"></i>-->
    <!--                    访客量-->
    <!--                    <em class="uv_num">-->
    <!--                        {{ this.$store.state.visitorAccess }}-->
    <!--                    </em>-->
    <!--                </span>-->
    <!--            </div>-->
            </div>
        </div>

        <!-- 移动端底部导航栏 -->
        <div v-show="isMobile" class="mobile-footer">
            <div class="nav-item" @click="goTo('/')" :class="{ active: currentPath === '/' }">
                <i class="el-icon-s-home"></i>
                <span>首页</span>
            </div>
            <div class="nav-item" @click="goTo('/subject')" :class="{ active: currentPath === '/subject' }">
                <i class="el-icon-collection"></i>
                <span>专栏</span>
            </div>
            <div class="nav-item" @click="goTo('/user_main')" :class="{ active: isUserPath }">
                <i class="el-icon-user"></i>
                <span>我的</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            path: null,
            day: "",
            hours: "",
            minute: "",
            second: "",
            isMobile: false,
            url: "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2020%2F0601%2Fba14f84ep00qb7neh000xd200jx00bog00gn009q.png&thumbnail=650x2147483647&quality=80&type=jpg"
        }
    },
    computed: {
        currentPath() {
            return this.path || '';
        },
        isUserPath() {
            return this.currentPath && this.currentPath.includes('/user');
        }
    },
    watch: {
        $route(newVal, old) {
            this.path = newVal.fullPath;
        }
    },
    created() {
        this.path = this.$route.fullPath;
        this.timer = setInterval(this.runTime, 1000);
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    destroyed() {
        window.removeEventListener('resize', this.checkMobile);
        clearInterval(this.timer);
    },
    methods: {
        runTime() {
            var timeold =
                new Date().getTime() -
                new Date(1627747200000).getTime();
            var msPerDay = 24 * 60 * 60 * 1000;
            var daysold = Math.floor(timeold / msPerDay);
            var day = new Date();
            this.day = daysold;
            this.hours = day.getHours();
            this.minute = day.getMinutes();
            this.second = day.getSeconds();
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        goTo(path) {

            if (path === '/notice' || path === '/user') {
                // 检查是否登录
                if (!this.$store.state.userInfo) {
                    this.$store.commit("setLoginFlag", true);
                    return;
                }
            }
            if (path === '/create') {
                // 检查是否登录
                if (!this.$store.state.userInfo) {
                    this.$store.commit("setLoginFlag", true);
                    return;
                }
                // 创作按钮点击时打开编辑器网站
                window.open('https://editor.mmming.cn/', '_blank');
                return;
            }
            
            if (this.path !== path) {
                this.$router.push(path);
            }
        }
    }
}
</script >
<style lang="scss" scoped >
@keyframes bgSize {
    0% {
        background-size: 300% 100%;
    }

    100% {
        background-size: 100% 100%;
    }
}

@keyframes yb {
    10% {
        transform: rotate(15deg);
    }

    20% {
        transform: rotate(-10deg);
    }

    30% {
        transform: rotate(5deg);
    }

    40% {
        transform: rotate(-5deg);
    }

    50%,
    100% {
        transform: rotate(0deg);
    }
}

.footer-wrapper {
    position: relative;
    width: 100%;
    min-height: 50px; // 确保有最小高度
}

.footer_container {
    padding: 15px 20px;
    position: relative;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--footer-background-color);
    background-position: 100% 0;
    animation: bgSize 5s infinite ease-in-out alternate;
    margin-top: 50px;
    transition: all 0.3s ease-in-out;
    opacity: 1;
    visibility: visible;

    &.v-show-false {
        opacity: 0;
        visibility: hidden;
    }

    .content {
        margin: 0 auto;
        position: relative;
        text-align: center;

        .site {
            font-size: 14px;
            color: var(--text-color);
            margin-left: 10px;

            p {
                margin: 10px 0;
            }

            a {
                text-decoration: none;
                color: var(--text-color);

                &:hover {
                    color: var(--theme-color);
                }
            }

            .run_time {
                height: 20px;
                align-items: center;

                svg {
                    width: 19px;
                    height: 19px;
                    vertical-align: -4px;
                    animation: yb 1s linear infinite;
                }

                span {
                    line-height: 20px;
                    font-size: 14px;
                    padding-left: 5px;

                    strong {
                        color: var(--theme-color);
                    }
                }
            }
        }

        .site-number {

            i {
                display: inline-block;
                font-size: 12px;
            }

            .site_pv,
            .site_uv,
            .online_user {
                position: relative;
                display: inline-block;
                margin-right: 4px;
                height: 24px;
                padding-left: 10px;
                line-height: 24px;
                overflow: hidden;
                font-size: 12px;
                font-weight: 700;
                color: var(--background-color);
                background: var(--text-color1);
                border-radius: 5px;
            }

            .pv_num,
            .uv_num,
            .online_num {
                display: inline-block;
                font-size: 12px;
                padding: 0 15px;
            }

            .pv_num {
                background: linear-gradient(0deg, #d0339b, #d03336);
            }

            .uv_num {
                background: linear-gradient(0deg, #e2c63a, #f58044);
            }

            .online_num {
                background: linear-gradient(0deg, #367eda, #964fdb);

            }


        }

    }
}

.mobile-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
    z-index: 999;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: env(safe-area-inset-bottom);
    transition: all 0.3s ease-in-out;
    opacity: 1;
    visibility: visible;

    &.v-show-false {
        opacity: 0;
        visibility: hidden;
    }

    .nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        color: #999;
        font-size: 12px;
        transition: all 0.3s;

        i {
            font-size: 20px;
            margin-bottom: 2px;
        }

        &.active {
            color: var(--theme-color);
        }

        &:active {
            opacity: 0.7;
        }
    }
}

@media screen and (max-width: 768px) {
    .footer_container {
        display: none;
    }

    .mobile-footer {
        display: flex;
    }

    // 为了防止底部导航遮挡内容，给body添加底部padding
    body {
        padding-bottom: calc(50px + env(safe-area-inset-bottom));
    }
}
</style>
